import { Stack } from "@kaltura/mediaspace-shared-styled";
import { MediaCardSkeleton } from "@kaltura/mediaspace-shared-media-card";

export const SearchResultsSkeleton = () => {
    return (
        <Stack direction={"column"} gap={2}>
            <MediaCardSkeleton />
            <MediaCardSkeleton />
            <MediaCardSkeleton />
            <MediaCardSkeleton />
        </Stack>
    );
};
